<header>
	<nav class="navbar">
		<div class="container">
			<div class="head-menu">
				<div class="left-logo" [ngClass]="{'ab-new-design-loan-type': newDesignLoanTypeABTest}">
					<p *ngIf="!recommendedLenderActive">
						<img class="logo" *ngIf="siteLogo" [src]="brandService.abLogoSrc !== '' ? brandService.abLogoSrc : brandService.logoSrc">
            			<img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}} also with extra" *ngIf="brandService.logoSrc && !siteLogo" [errorSrc]="brandService.logoWasabiSrc">
					</p>
					<p *ngIf="recommendedLenderActive">
						<!-- <img class="logo" src="/assets/images/recommended_logo.png" alt="Recommended Lender" *ngIf="recommendedLenderActive"> -->
						<img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc && !recommendedLenderActive" [errorSrc]="brandService.logoWasabiSrc">
					</p>
				</div>
				<div class="phone" *ngIf="lenderHeadPhoneStatus && lenderHeadPhoneStatus.answer && !brandService.isTop10">
					<a class="has-text-grey-dark" href="tel:{{ lenderHeadPhoneStatus.phone }}" target="_blank">
						<small>or call for rates...</small>
						<i class="fas fa-phone"></i>{{ lenderHeadPhoneStatus.phonefancy }}
					</a>
				</div>
			</div>
		</div>
	</nav>
</header>
